module.exports = __webpack_public_path__ + "img/kk-logo-red.ef50af86.svg";